var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcPersonEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ifzow95aca",
    d: "M10 10c1.842 0 3.333-1.492 3.333-3.333 0-1.842-1.491-3.334-3.333-3.334S6.667 4.825 6.667 6.667C6.667 8.508 8.158 10 10 10zm0 1.667c-2.225 0-6.667 1.116-6.667 3.333v1.667h13.334V15c0-2.217-4.442-3.333-6.667-3.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0317dbtwlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifzow95aca"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2565C7",
    mask: "url(#0317dbtwlb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPersonEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-person-edit.68d9769b.svg";
export { ForwardRef as ReactComponent };